// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"8d5bc280","298":"a02a906f","684":"04f75beb","772":"aaf0c473","823":"818a809e","990":"ea810f54"}[chunkId] + ".chunk.js";
};